import { useNavigate } from 'react-router'
import { BottomSheet, ServiceIcon, SERVICE_LABEL, type ServiceActivity } from '@waago/ui'
import { ACTIVITY_ROUTE } from '../lib/activities'

/**
 * The centre button's sheet — "Rechercher un service" (frame 4760:6152).
 *
 * Four square tiles rather than a list: the whole point of the raised button is
 * that starting a request is one tap from anywhere, and a list would put the
 * fourth option below a scroll on a short phone.
 */
export function MoreSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const navigate = useNavigate()

  return (
    <BottomSheet open={open} onClose={onClose} title="Rechercher un service">
      <p className="mb-4 text-center text-sm leading-[22px] text-slate-500">
        Choisisser le type de service que vous voulez demander.
      </p>

      <div className="grid grid-cols-4 gap-1.5">
        {(Object.keys(SERVICE_LABEL) as ServiceActivity[]).map((activity) => (
          <button
            key={activity}
            type="button"
            onClick={() => {
              onClose()
              void navigate(ACTIVITY_ROUTE[activity])
            }}
            className="border-brand-400 flex h-[78px] flex-col items-center justify-center gap-1.5 rounded-lg border bg-slate-100 px-1 text-slate-600"
          >
            <ServiceIcon activity={activity} className="text-brand-600" />
            <span className="text-xs leading-4 font-medium">{SERVICE_LABEL[activity]}</span>
          </button>
        ))}
      </div>
    </BottomSheet>
  )
}
